import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { Social } from '@/components/signup/account-creation/components/social/social';

export const LoggedOutJiraProductTourAccountCreation = () => {
	return <AccountCreation Login={null} Social={<Social providers={{ google: 'Google' }} />} />;
};
